module.exports = __webpack_public_path__ + "img/google.02d31de0.svg";